// extracted by mini-css-extract-plugin
export default {"textInfo":"FormBuilder_textInfo__lpdTc"};